import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import DateInput from "@/components/common/DateInput";

export const isBlank = (v) => v == null || String(v).trim() === "";

export function missingFields(fields = [], values = {}) {
  return fields.filter((f) => f.required && isBlank(values[f.key]));
}

function FieldInput({ field, value, onChange }) {
  const testid = `stage-field-${field.key}`;
  if (field.type === "select") {
    return (
      <Select value={value || ""} onValueChange={onChange}>
        <SelectTrigger className="mt-1" data-testid={testid}><SelectValue placeholder="Select" /></SelectTrigger>
        <SelectContent>{field.options.map((o) => <SelectItem key={o} value={o}>{o}</SelectItem>)}</SelectContent>
      </Select>
    );
  }
  if (field.type === "textarea") {
    return <Textarea rows={2} className="mt-1" value={value || ""} onChange={(e) => onChange(e.target.value)} data-testid={testid} />;
  }
  if (field.type === "date") {
    return <DateInput value={value || ""} onChange={onChange} className="mt-1 h-10" testid={testid} />;
  }
  const type = field.type === "number" ? "number" : "text";
  return <Input type={type} min={type === "number" ? "0" : undefined} className="mt-1" value={value || ""} onChange={(e) => onChange(e.target.value)} data-testid={testid} />;
}

/** Renders the server-defined fields for a stage; highlights the ones still missing. */
export default function StageFieldsForm({ stage, fields = [], values, onChange, highlightMissing = false }) {
  if (!fields.length) return null;
  const missing = new Set(missingFields(fields, values).map((f) => f.key));
  return (
    <div className="space-y-3 rounded-lg bg-slate-50 border border-slate-200 p-3" data-testid="stage-fields-form">
      <div className="text-xs font-semibold uppercase tracking-wide text-slate-500">Details for {stage}</div>
      {fields.map((f) => (
        <div key={f.key}>
          <Label className="text-sm">
            {f.label}{f.required && <span className="text-rose-500"> *</span>}
            {highlightMissing && missing.has(f.key) && <span className="ml-2 text-xs font-medium text-amber-600">missing</span>}
          </Label>
          <FieldInput field={f} value={values[f.key]} onChange={(v) => onChange({ ...values, [f.key]: v })} />
        </div>
      ))}
    </div>
  );
}
